import { InsertMode } from "@entaconsulting/form";

const getInsertByMode = (mode: InsertMode, insertAt: number) => {
  return mode === "colAfter" ? insertAt + 1 : insertAt;
};

export default getInsertByMode;
